import { useContext, useEffect, useState } from "react";
import { CreateContext } from "../../../contexts/CreateContext";
import { IconContainer } from "../../Buttons/IconContainer";
import { UnderlinedButton } from "../../Buttons/UnderlinedButton";
import { UploadPreview } from "../Preview/UploadPreview"
import Upload from "../../../public/images/icons/upload.svg";
import MediaView from "../../../public/images/icons/media-view.svg";
import MediaManage from "../../../public/images/icons/media-manage.svg";
import VerifiedIcon from "../../../public/images/icons/verified.svg";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";


export const CompleteStep = () => {
    const { uploadManager, reset, setStep, galleryItems, createdMedia } = useContext(CreateContext);
    const { t } = useTranslation('create');

    const uploadItem = galleryItems[0];
    const isGallery = galleryItems.length > 1;

    if (!uploadItem) {
        return null;
    }

    let titleText;
    if (isGallery) {
        titleText = t('gallery');
    }
    else {
        if (uploadItem.coverType == "photo") {
            titleText = t('photo');
        }
        else {
            titleText = t('video');
        }
    }

    return (
        <>
            <div className="flex flex-col sm:flex-row gap-x-16">
                <div className={`flex-1`}>
                    <UploadPreview className={`rounded-[16px] ${isGallery ? "gallery rounded-2xl" : ""}`} cover={uploadItem.uploadItem?.poster} coverType={uploadItem.coverType} />
                </div>
                <div className="flex-1 flex flex-col gap-y-4">
                    <p className="flex items-center flex-row gap-x-2">
                        <VerifiedIcon className="w-8 h-8" />
                        {t('completeStep.title')}</p>
                    <div className="flex flex-wrap">
                        <UnderlinedButton onClick={reset} underlineType="secondary">
                            <IconContainer responsiveText={false} icon={<Upload className="w-8 h-8 stroke-white stroke-[3px] hidden sm:block" />} label={t('completeStep.uploadAnother')} />
                        </UnderlinedButton>

                        <UnderlinedButton renderContainer={(props) => <Link {...props} />} href={`watch/${createdMedia!.slug}`}>
                            <IconContainer responsiveText={false} icon={<MediaView className="w-8 h-8 stroke-white hidden sm:block" />} label={`${t('completeStep.goTo')}${titleText}`} />
                        </UnderlinedButton>

                        {/* <UnderlinedButton renderContainer={(props) => <Link {...props} />} href={`user/manage/`}>
                            <IconContainer responsiveText={false} icon={<MediaManage className="w-8 h-8 stroke-white hidden sm:block" />} label="Manage" />
                        </UnderlinedButton> */}
                    </div>
                </div>
            </div>
        </>
    )
}